import { render, staticRenderFns } from "./HiaRichText.vue?vue&type=template&id=1fdfde5b&scoped=true&"
import script from "./HiaRichText.vue?vue&type=script&lang=js&"
export * from "./HiaRichText.vue?vue&type=script&lang=js&"
import style0 from "./HiaRichText.vue?vue&type=style&index=0&id=1fdfde5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdfde5b",
  null
  
)

export default component.exports